import { render, staticRenderFns } from "./menu-duplicates-check.vue?vue&type=template&id=40a25b0b&"
import script from "./menu-duplicates-check.vue?vue&type=script&lang=js&"
export * from "./menu-duplicates-check.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./menu-duplicates-check-i18n.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fweb%2Fsrc%2Fcomponents%2Ftasks%2Fedit%2Fbackoffice%2Fcomponents%2Fmenu-duplicates-check.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports